import { getEnvVar } from '../getEnvVar/getEnvVar';
export const CURRENT_APP_VERSION = getEnvVar(process.env.BUILD_TAG, '');
